<template>
  <div>
    <div class="brand-card-lg">
      <div>
        <p v-if="!hasSubscription" class="title">Account Billing</p>
        <div v-if="!hasSubscription">
          <p class="subtitle mt-3 text-brand-brown text-lg font-medium">
            You will need to <a href="/upgrade" class="underline text-brand-blue font-semibold">upgrade your plan</a> before going live with Churnkey.
          </p>
          <div class="mt-4">
            <a href="/upgrade">
              <el-button type="primary" class="font-bold" size="large">View Our Plans</el-button>
            </a>
          </div>
        </div>
        <div v-else>
          <!-- <p class="text-sm text-gray-600 mt-1">View and manage your subscription details.</p> -->
          <p class="title">Subscription and Billing</p>
          <p class="subtitle mt-3 text-brand-brown text-lg font-medium">
            You are currently subscribed to the
            <span v-if="subscription.plan.metered" class="font-semibold lowercase"
              >{{ subscription.plan.name }} plan starting at ${{ subscription.plan.amount / 100 }} /{{ subscription.plan.interval }}
            </span>
            <span v-else class="font-semibold lowercase"
              >{{ subscription.plan.name }} plan for ${{ subscription.plan.amount / 100 }} /{{ subscription.plan.interval }} </span
            >.
          </p>
          <div class="mt-4">
            <el-button v-can-enable="'billing:read'" type="primary" @click="goToPortal" :loading="loadingPortal"> Manage Subscription </el-button>
          </div>
          <div class="bg-brand-light-blue px-6 py-4 mt-6 rounded-lg">
            <p class="text-brand-black font-semibold text-sm">Note:</p>
            <div class="text-brand-black font-medium text-sm mt-2 space-y-2">
              <p>For invoices dated before July 2023, please visit our legacy billing portal.</p>
            </div>
            <el-button v-can-enable="'billing:read'" type="text" @click="goToLegacyPortal" :loading="loadingPortal">
              <span class="font-semibold">Download Old Invoices </span></el-button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/camelcase */
import * as actions from '@/store/action-types';
import { mapGetters } from 'vuex';
import userService from '@/api/user.service';

export default {
  name: 'Billing',
  data() {
    return {
      isLoading: true,
      loadingPortal: false,
      loadingLegacyPortal: false,
    };
  },
  computed: {
    ...mapGetters(['verifiedStripeUser', 'verifiedNotStripeUser', 'payingCustomer']),
    hasSubscription() {
      return !!this.$store.getters.userOrgSubscription;
    },
    subscription() {
      return this.$store.getters.userOrgSubscription;
    },
    org() {
      return this.$store.state.org;
    },
    user() {
      return this.$store.state.user;
    },
  },
  async created() {
    await this.$store.dispatch(actions.SYNC_ORG);
  },
  mounted() {
    this.isLoading = false;
  },
  methods: {
    async goToPortal() {
      this.loadingPortal = true;
      try {
        const returnURL = `${window.location.origin}${this.$route.path}`;
        const portalSession = await userService.getPortalSession(this.user._id, returnURL);
        window.location.href = portalSession.url;
      } catch (e) {
        console.log(e);
        this.$message({
          type: 'error',
          message: 'Something went wrong while directing you to the billing portal. Please refresh your page.',
        });
        this.loadingPortal = false;
      }
    },
    async goToLegacyPortal() {
      this.loadingLegacyPortal = true;
      try {
        const returnURL = `${window.location.origin}${this.$route.path}`;
        const portalSession = await userService.getLegacyPortalSession(this.user._id, returnURL);
        window.location.href = portalSession.url;
      } catch (e) {
        console.log(e);
        this.$message({
          type: 'error',
          message: 'Something went wrong while directing you to the billing portal. Please refresh your page.',
        });
        this.loadingLegacyPortal = false;
      }
    },
  },
};
</script>
